export default __webpack_public_path__ + "static/media/icon-back.804c4da1.svg";